import { ReportFeatures } from '@hcs/types';

export const SUBJECT_PROPERTY_DETAILS_SECTION_FEATURES = [
  ReportFeatures.SubjectPropertyDetails,
  ReportFeatures.SubjectEditDetails,
  ReportFeatures.SubjectEditCondition,
  ReportFeatures.SubjectDataSources,
];
